import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "cardWrapper" };
const _hoisted_2 = { class: "imageContent pa-4" };
const _hoisted_3 = { class: "d-flex justify-space-between align-start" };
const _hoisted_4 = { class: "categoryText font-weight-bold" };
const _hoisted_5 = {
    key: 1,
    class: "pa-4 d-flex align-center"
};
const _hoisted_6 = { class: "logoUrl" };
const _hoisted_7 = ["src"];
const _hoisted_8 = { class: "merchantInfo" };
const _hoisted_9 = {
    class: "font-weight-bold",
    style: 'font-size: 14px; font-weight: 500;'
};
const _hoisted_10 = { class: "spendInfo" };
const _hoisted_11 = { class: "savingsInfo text-right" };
const _hoisted_12 = { class: "saveText" };
const _hoisted_13 = { class: "font-weight-bold savingsAmount" };
const _hoisted_14 = { class: "savingsPercentage" };
const _hoisted_15 = {
    key: 2,
    class: "smallDetailsSection"
};
const _hoisted_16 = {
    class: "icon-col",
    style: {}
};
const _hoisted_17 = ["src"];
const _hoisted_18 = { class: "smallDetailsContent" };
const _hoisted_19 = { class: "smallMerchantName" };
const _hoisted_20 = {
    key: 0,
    class: "smallSavingsAmount"
};
const _hoisted_21 = {
    key: 1,
    class: "smallSavingsAmount"
};
const _hoisted_22 = {
    key: 2,
    class: "smallSaveText"
};
const _hoisted_23 = { style: { "font-weight": "bold" } };
import FavoriteChip from './FavoriteChip.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherRecommendedForYou',
    props: {
        small: { type: Boolean },
        imageUrl: {},
        category: {},
        isFavorited: { type: Boolean },
        cardLabel: {},
        merchantLogoUrl: {},
        merchantName: {},
        spendAmount: {},
        spendLabel: {},
        savingsAmount: {},
        savingsPercentage: {},
        formatter: {}
    },
    emits: ["favorite-clicked"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_img = _resolveComponent("v-img");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_card, {
                    class: _normalizeClass(["recommendedCard", { 'small': _ctx.small }]),
                    elevation: "0",
                    ripple: false,
                    variant: "flat"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                            src: _ctx.imageUrl,
                            class: "imageUrl",
                            cover: true
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.category), 1),
                                        _createVNode(FavoriteChip, {
                                            isFavorited: _ctx.isFavorited,
                                            onFavoriteClicked: _cache[0] || (_cache[0] = ($event) => (emit('favorite-clicked', $event)))
                                        }, null, 8, ["isFavorited"])
                                    ]),
                                    _createVNode(_component_v_spacer)
                                ])
                            ]),
                            _: 1
                        }, 8, ["src"]),
                        (_ctx.cardLabel)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                class: "spendLabel",
                                small: ""
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.cardLabel), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (!_ctx.small)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("img", { src: _ctx.merchantLogoUrl }, null, 8, _hoisted_7)
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.merchantName), 1),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createTextVNode(_toDisplayString(_ctx.spendLabel) + ": ", 1),
                                        _createElementVNode("span", null, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.spendAmount), 1)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[1] || (_cache[1] = _createTextVNode("Save ")),
                                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatter.format(_ctx.savingsAmount)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.savingsPercentage), 1),
                                        _cache[2] || (_cache[2] = _createTextVNode("%"))
                                    ])
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("img", {
                                        src: _ctx.merchantLogoUrl,
                                        class: "icon"
                                    }, null, 8, _hoisted_17)
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.merchantName), 1),
                                    (_ctx.savingsAmount)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.formatter.format(_ctx.savingsAmount)), 1))
                                        : _createCommentVNode("", true),
                                    (_ctx.savingsPercentage && !_ctx.savingsAmount)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.savingsPercentage) + "%", 1))
                                        : _createCommentVNode("", true),
                                    (_ctx.savingsPercentage && _ctx.savingsAmount)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                            _cache[3] || (_cache[3] = _createTextVNode("Save: ")),
                                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.savingsPercentage) + "%", 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                    ]),
                    _: 1
                }, 8, ["class"])
            ]));
        };
    }
});
